import ReaxlNextLink from './ReaxlNextLink';

export default ReaxlNextLink;
